<template>
  <div class="mirror-comment-form">
    <drawer-dialog-controls
      class="dialog-controls"
      :is-loading="isLoading"
      @close="$emit('close')"
      @save="onSubmit"
    >
      Add comment to mirror {{ mirror?.name || '-' }}
    </drawer-dialog-controls>
    <v-card-text class="flex-grow-1 pt-6">
      <span class="body-2 font-weight-medium">Comment</span>
      <v-textarea
        v-model="comment"
        outlined
        dense
        hide-details
        rows="6"
        class="mt-2"
        placeholder="Enter comment"
      />
    </v-card-text>
  </div>
</template>

<script>
  import { DrawerDialogControls } from '@/components/core/DrawerDialog'

  export default {
    name: 'MirrorCommentForm',
    components: {
      DrawerDialogControls,
    },
    props: {
      mirror: {
        type: Object,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        comment: this.mirror?.settings?.comment || '',
      }
    },
    watch: {
      mirror: {
        immediate: true,
        handler(nextMirror) {
          this.comment = nextMirror?.settings?.comment || ''
        },
      },
    },
    methods: {
      onSubmit() {
        if (!this.mirror) return
        const mirror = {
          mirror_id: this.mirror.mirror_id,
          entity_id: this.mirror.entity_id,
          group_mirror_id: this.mirror.group_mirror_id,
          settings: {
            ...(this.mirror.settings || {}),
          comment: this.comment,
          },
        }
        this.$emit('save', { mirror })
      },
    },
  }
</script>

<style scoped>
</style>
